﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Mate } from "@models/configurators/output-fields/cad/mates/mate";
import { eOutputFieldType } from "@models/enums";
import { ICadCoordinateSystemMate } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadCoordinateSystemMate, eOutputFieldType.cadCoordinateSystemMate)
export class CadCoordinateSystemMate extends Mate implements ICadCoordinateSystemMate {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: string;
}
